<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <!-- Dialog error autorizacao -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="autorizacaoDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('system.alert') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemAutorizacaoDialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="logout">{{ $t('operation.logout') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!-- Fechar mês -->
    <v-dialog v-model="dialogFecharMes" max-width="560" persistent>
      <v-card>
        <v-card-title class="headline">{{ $t('closingMonth.closeTitle') }}</v-card-title>
        <v-card-text>
          <p>{{ $t('closingMonth.closeConfirm', { valor: currencyFormatter(totalCompensationAmount) }) }}</p>
          <p class="text-caption grey--text text--darken-1">{{ $t('closingMonth.closeHint') }}</p>
          <v-textarea v-model="observacoesFechamento" :label="$t('closingMonth.notes')" rows="3"
            counter="1000" maxlength="1000" outlined dense></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :disabled="salvandoFechamento" @click="dialogFecharMes = false">{{ $t('button.cancel') }}</v-btn>
          <v-btn color="success" class="white--text" :loading="salvandoFechamento" @click="confirmarFecharMes">
            {{ $t('closingMonth.closeButton') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Reabrir mês -->
    <v-dialog v-model="dialogReabrirMes" max-width="560" persistent>
      <v-card>
        <v-card-title class="headline">{{ $t('closingMonth.reopenTitle') }}</v-card-title>
        <v-card-text>
          <p>{{ $t('closingMonth.reopenConfirm') }}</p>
          <v-textarea v-model="motivoReabertura" :label="$t('closingMonth.reason')" rows="3"
            counter="1000" maxlength="1000" outlined dense
            :rules="[(v) => !!(v && v.trim()) || $t('closingMonth.reasonRequired')]"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :disabled="salvandoFechamento" @click="dialogReabrirMes = false">{{ $t('button.cancel') }}</v-btn>
          <v-btn color="warning" class="white--text" :loading="salvandoFechamento"
            :disabled="!motivoReabertura || !motivoReabertura.trim()" @click="confirmarReabrirMes">
            {{ $t('closingMonth.reopenButton') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Overlay Loading PDF -->
    <v-overlay :value="loadingPdf" z-index="9999">
      <div style="text-align: center;">
        <v-progress-circular
          indeterminate
          size="64"
          color="primary"
        ></v-progress-circular>
        <div style="color: white; margin-top: 20px; font-size: 18px; font-weight: 500;">
          {{ $t('relSubsidy.generatingPdf') }}
        </div>
        <div style="color: white; margin-top: 10px; font-size: 14px; opacity: 0.8;">
          {{$t('relSubsidy.waitWhileRelatory')}}
        </div>
      </div>
    </v-overlay>

    <!-- Filtros -->
    <v-toolbar style="
          margin-bottom: 10px;
          margin-left: 3px;
          margin-top: 10px;
          border-radius: 10px;
          padding-top: 60px;
          padding-bottom: 20px;
          height: 170px;
        ">
      <v-container>
        <v-form ref="form" v-model="formValidado">
          <v-row>
            <v-col cols="12" sm="4" md="3">
              <v-autocomplete v-model="idEmpresaSelected" :items="empresas" item-text="razao_social"
                item-value="id_empresa" clearable :label="$tc('company.self', 1)"
                :rules="[(v) => !!v || $t('area.selectCompany')]" @change="onEmpresaSelectChanged"></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-autocomplete v-model="idClienteSelected" :items="clientesSelect" item-text="nome_cliente"
                item-value="id_cliente" clearable :label="$tc('client.self', 1)"
                :disabled="!idEmpresaSelected"></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="2">
              <v-select v-model="anoSelected" :items="anos" :label="$t('datetime.year')"
                :rules="[(v) => !!v || 'Selecione um ano']" @change="onAnoChange"></v-select>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-select v-model="mesSelected" :items="mesesDisponiveis" item-text="text" item-value="value" 
                :label="$t('datetime.month')" :rules="[(v) => v !== null && v !== undefined || 'Selecione um mês']"></v-select>
            </v-col>
            <v-col cols="12" sm="1" md="1" class="d-flex align-center justify-center" style="gap: 10px;">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                    @click="populaRelatorio">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('operation.search') }}</span>
              </v-tooltip>
              
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small fab color="primary" class="white--text" v-bind="attrs" v-on="on"
                    @click="exportarPaginaPDF" :disabled="!total || total.valor_frota_total === undefined">
                    <v-icon>mdi-file-pdf-box</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('system.labels.exportToPdf') }}</span>
              </v-tooltip>

              <!-- Fechamento do mês: congela as viagens do período para o total parar de variar -->
              <v-tooltip v-if="podeFecharMes && !mesEstaFechado" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small fab color="success" class="white--text" v-bind="attrs" v-on="on"
                    :disabled="!total || total.valor_frota_total === undefined || !statusFechamentoCarregado"
                    @click="abrirDialogFecharMes">
                    <v-icon>mdi-lock-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('closingMonth.closeButton') }}</span>
              </v-tooltip>

              <v-tooltip v-if="podeReabrirMes && mesEstaFechado && fechamentoCorrespondeAosFiltros" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small fab color="warning" class="white--text" v-bind="attrs" v-on="on"
                    @click="abrirDialogReabrirMes">
                    <v-icon>mdi-lock-open-variant-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('closingMonth.reopenButton') }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-toolbar>

    <!-- Conteúdo para exportar como PDF -->
    <div ref="pdfContent">
    <!-- Indicativo de mês fechado. Vira alerta quando o total recalculado saiu do valor
         congelado (a tarifa ainda não é congelada nesta fase). -->
    <v-alert v-if="mesEstaFechado && fechamentoCorrespondeAosFiltros" dense text
      :type="fechamentoDivergente ? 'warning' : 'info'"
      :icon="fechamentoDivergente ? 'mdi-alert-outline' : 'mdi-lock-check-outline'"
      style="border-radius: 10px; margin-top: 10px;">
      <div style="font-weight: 600;">{{ $t('closingMonth.closedTitle') }}</div>
      <div>{{ fechamentoResumo }}</div>
      <div v-if="fechamentoMes.observacoes">{{ fechamentoMes.observacoes }}</div>
      <div v-if="fechamentoDivergente" style="margin-top: 4px; font-weight: 600;">
        {{ fechamentoDivergenciaTexto }}
      </div>
    </v-alert>
    <!-- Cards de Totais Gerais -->
    <v-row v-if="total && total.valor_frota_total !== undefined" style="margin-bottom: 20px; margin-top: 10px;">
      <v-col cols="12" class="py-0" v-if="cicloPagamentoCaption">
        <div class="grey--text text--darken-1 text-caption mb-2">{{ cicloPagamentoCaption }}</div>
      </v-col>
      <v-col cols="12" sm="6" :md="mdCardMaoObra">
        <v-card class="elevation-5" style="border-radius: 10px; height: 100%;">
          <v-card-text>
            <div style="color: #666; font-size: 12px; text-transform: uppercase; font-weight: 600; margin-bottom: 5px;">
              {{$t('relSubsidy.mediumFleet')}}
            </div>
            <div style="color: #1976d2; font-size: 28px; font-weight: bold;">
              {{ total.frota_total }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="2" v-if="Number(total.motoristas_total) > 0">
        <v-card class="elevation-5" style="border-radius: 10px; height: 100%;">
          <v-card-text>
            <div style="color: #666; font-size: 12px; text-transform: uppercase; font-weight: 600; margin-bottom: 5px;">
              {{$t('relSubsidy.driversCount')}}
            </div>
            <div style="color: #1976d2; font-size: 28px; font-weight: bold;">
              {{ Math.round(Number(total.motoristas_total)) }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card class="elevation-5" style="border-radius: 10px; height: 100%;">
          <v-card-text>
            <div style="color: #666; font-size: 12px; text-transform: uppercase; font-weight: 600; margin-bottom: 5px;">
              {{$t('relSubsidy.fleetValue')}}
            </div>
            <div style="color: #2e7d32; font-size: 28px; font-weight: bold;">
              {{ currencyFormatter(total.valor_frota_total) }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" :md="mdCardMaoObra">
        <v-card class="elevation-5" style="border-radius: 10px; height: 100%;">
          <v-card-text>
            <div style="color: #666; font-size: 12px; text-transform: uppercase; font-weight: 600; margin-bottom: 5px;">
              {{$t('relSubsidy.totalKm')}}
            </div>
            <div style="color: #1976d2; font-size: 28px; font-weight: bold;">
              {{ numberFormatter(total.km_total || 0) }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card class="elevation-5" style="border-radius: 10px; height: 100%;">
          <v-card-text>
            <div style="color: #666; font-size: 12px; text-transform: uppercase; font-weight: 600; margin-bottom: 5px;">
              {{$t('relSubsidy.valueKm')}}
            </div>
            <div style="color: #2e7d32; font-size: 28px; font-weight: bold;">
              {{ currencyFormatter(total.valor_km_total) }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="hasScorecardMelibrasil && scorecardResumo.valor_desconto_scorecard > 0" style="margin-bottom: 12px;">
      <v-col cols="12" sm="6" md="4">
        <v-card outlined>
          <v-card-text>
            <div class="text-caption grey--text">{{ $t('relSubsidy.scorecard.pointsLabel') }}</div>
            <div class="text-h6">{{ scorecardResumo.pontos_scorecard != null ? numberFormatter(scorecardResumo.pontos_scorecard) : '-' }}</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card outlined>
          <v-card-text>
            <div class="text-caption grey--text">{{ $t('relSubsidy.scorecard.discountLabel') }}</div>
            <div class="text-h6 error--text">{{ currencyFormatter(scorecardResumo.valor_desconto_scorecard) }}</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Card de Total Geral -->
    <v-row v-if="total && total.valor_frota_total !== undefined" style="margin-bottom: 20px;">
      <v-col cols="12">
        <v-card class="elevation-7 primary" style="border-radius: 10px;">
          <v-card-text>
            <div style="color: white; font-size: 14px; text-transform: uppercase; font-weight: 600; margin-bottom: 8px; opacity: 0.9;">
              {{this.$t('relSubsidy.compensationTotal')}}
            </div>
            <div style="color: white; font-size: 42px; font-weight: bold;">
              {{ currencyFormatter(totalCompensationAmount) }}
            </div>
            <div v-if="hasScorecardMelibrasil && total.valor_desconto_scorecard > 0" style="color: rgba(255,255,255,0.85); font-size: 13px; margin-top: 8px;">
              {{ $t('relSubsidy.scorecard.compensationBreakdown', {
                bruto: currencyFormatter(total.valor_total_bruto),
                desconto: currencyFormatter(total.valor_desconto_scorecard),
              }) }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Tabela 1: Resumo Total -->
    <merus-data-table :headers="headersTotal" :items="totalTarifas" dense class="elevation-7" locale="pt"
      :loading="loadingRelatorio" :loading-text="$t('system.messages.loading')" :default-multi-sort="defaultSortTotal"
      style="border-radius: 10px; margin-bottom: 10px;"
      @update:displayedItems="displayedTotalTarifasItemsForExport = $event">
      <template v-slot:toolbar>
        <CadastroToolbar :title="$t('relSubsidy.totalRemuneration')" :token="token"
          :items="displayedTotalTarifasItemsForExport !== null ? displayedTotalTarifasItemsForExport : totalTarifas"
          csv-title="relatoriosubsidiomensaltotal" :csv-headers="headersTotal"
          :pdf-title="$t('relSubsidy.totalRemuneration')" :pdf-headers="headersTotal"
          pdf-filename="relatoriosubsidiomensaltotal" hide-search>
        </CadastroToolbar>
      </template>
      <template v-slot:item.descricao_tipo_veiculo="{ item }">
        <span :style="item.style">{{ item.descricao_tipo_veiculo }}</span>
      </template>
      <template v-slot:item.frota_operacional_media="{ item }">
        <span :style="item.style">{{ item.frota_operacional_media }}</span>
      </template>
      <template v-slot:item.km_total="{ item }">
        <span :style="item.style">{{ item.km_total }}</span>
      </template>
      <template v-slot:item.valor_tarifa_km="{ item }">
        <span>{{ item.valor_tarifa_km ? currencyFormatter(item.valor_tarifa_km) : '' }}</span>
      </template>
      <template v-slot:item.valor_tarifa_frota="{ item }">
        <span>{{ item.valor_tarifa_frota ? currencyFormatter(item.valor_tarifa_frota) : '' }}</span>
      </template>
      <template v-slot:item.valor_total="{ item }">
        <span style="font-weight: bold;">{{ currencyFormatter(item.valor_total) }}</span>
      </template>
      <template v-slot:item.valor_total_km="{ item }">
        <span :style="item.style">{{ currencyFormatter(item.valor_total_km) }}</span>
      </template>
      <template v-slot:item.valor_total_frota="{ item }">
        <span :style="item.style">{{ currencyFormatter(item.valor_total_frota) }}</span>
      </template>
      <template v-slot:item.cod_contrato_exibicao="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <span v-on="on" :style="item.style">{{ item.cod_contrato_exibicao || '—' }}</span>
          </template>
          <span style="white-space: pre-line;">{{ contratoTooltip(item) }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.origem_valor_label="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-chip v-on="on" x-small outlined :color="origemValor(item).color">
              <v-icon v-if="origemValor(item).icon" x-small left>{{ origemValor(item).icon }}</v-icon>
              {{ origemValor(item).label }}
            </v-chip>
          </template>
          <span style="white-space: pre-line;">{{ origemValor(item).tooltip }}</span>
        </v-tooltip>
      </template>
    </merus-data-table>

    <!-- Tabela 2: Analítico Dia a Dia - KM -->
    <merus-data-table :headers="headersAnaliticoKm" :items="analiticoKm" :loading="loadingRelatorio"
      :default-multi-sort="defaultMultiSortAnalitico" :loading-text="$t('system.messages.loading')" @update:displayedItems="displayedAnaliticoKmItemsForExport = $event"
      style="margin-bottom: 10px;"

 cod-tabela="RELSUBSIDIOMENSAL__ANALITICO_KM" @update:headers="headersAnaliticoKm = $event">
      <template v-slot:toolbar>
        <CadastroToolbar :title="$t('relSubsidy.analisysCalcKm')" :token="token" :items="displayedAnaliticoKmItemsForExport !== null ? displayedAnaliticoKmItemsForExport : analiticoKm"
          csv-title="relsubsidiomensalanaliticokm" :pdf-title="$t('relSubsidy.analisysCalcKm')"
          :pdf-headers="headersAnaliticoKm" pdf-filename="relsubsidiomensalanaliticokm" 
          :csv-headers="headersAnaliticoKm" csv-filename="relsubsidiomensalanaliticokm" 
          :pdf-subtitle="pdfSubtitle" hide-search>
        </CadastroToolbar>
      </template>

      <template v-slot:item.descricao_tipo_veiculo="{ item }">
        <span>{{ item.descricao_tipo_veiculo }}</span>
      </template>

      <template v-slot:item.km_total="{ item }">
        <span>{{ item.km_total }}</span>
      </template>
      
      <template v-slot:item.valor_tarifa_km="{ item }">
        <span>{{ currencyFormatter(item.valor_tarifa_km) }}</span>
      </template>

      <template v-slot:item.valor_total_km="{ item }">
        <span>{{ currencyFormatter(item.valor_total_km) }}</span>
      </template>
    </merus-data-table>

    <!-- Tabela 3: Analítico Dia a Dia - Frota -->
    <merus-data-table :headers="headersAnaliticoFrota" :items="analiticoFrota" :loading="loadingRelatorio"
      :default-multi-sort="defaultMultiSortAnalitico" :loading-text="$t('system.messages.loading')" @update:displayedItems="displayedAnaliticoFrotaItemsForExport = $event"
      style="margin-bottom: 10px;"

 cod-tabela="RELSUBSIDIOMENSAL__ANALITICO_FROTA" @update:headers="headersAnaliticoFrota = $event">
      <template v-slot:toolbar>
        <CadastroToolbar :title="$t('relSubsidy.analisysCalcFleet')" :token="token" :items="displayedAnaliticoFrotaItemsForExport !== null ? displayedAnaliticoFrotaItemsForExport : analiticoFrota"
          csv-title="relsubsidiomensalanaliticofrota" :pdf-title="$t('relSubsidy.analisysCalcFleet')"
          :pdf-headers="headersAnaliticoFrota" pdf-filename="relsubsidiomensalanaliticofrota"
          :csv-headers="headersAnaliticoFrota" csv-filename="relsubsidiomensalanaliticofrota" 
          :pdf-subtitle="pdfSubtitle" hide-search>
        </CadastroToolbar>
      </template>

      <template v-slot:item.num_veiculos_pico_manha="{ item }">
        <span>{{ item.num_veiculos_pico_manha }}</span>
      </template>

      <template v-slot:item.num_veiculos_pico_tarde="{ item }">
        <span>{{ item.num_veiculos_pico_tarde }}</span>
      </template>

      <template v-slot:item.frota_operacional="{ item }">
        <span>{{ numberFormatter(item.frota_operacional) }}</span>
      </template>

      <template v-slot:item.valor_tarifa_frota="{ item }">
        <span>{{ currencyFormatter(item.valor_tarifa_frota) }}</span>
      </template>
    </merus-data-table>
    </div>
    <!-- Fim do conteúdo para PDF -->
    
    <!-- Componente vue-html2pdf -->
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1500"
      filename="relatorio_subsidio_mensal"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="100%"
      :html-to-pdf-options="htmlToPdfOptions"
      @progress="onPdfProgress"
      @hasStartedGeneration="onPdfStart"
      @hasGenerated="onPdfComplete"
      @beforeDownload="beforeDownload"
      @hasDownloaded="onPdfDownloaded"
      ref="html2Pdf"
    >
      <section slot="pdf-content" style="padding: 30px 40px;">
        <!-- Cabeçalho do PDF -->
        <div style="text-align: center; margin-bottom: 25px;">
          <h1 style="color: #1976d2; margin-bottom: 10px;">{{ $t('relSubsidy.totalRemuneration') }}</h1>
          <h3 style="color: #666;">{{ pdfSubtitle }}</h3>
          <h5 style="color: #4a4a4a">{{ pdfDadosEmissao }}</h5>
        </div>
        
        <!-- Cards de Totais -->
        <div v-if="total && total.valor_frota_total !== undefined" style="display: flex; justify-content: space-around; margin-bottom: 25px; gap: 15px;">
          <div style="flex: 1; padding: 12px; border: 2px solid #1976d2; border-radius: 8px;">
            <div style="color: #666; font-size: 10px; text-transform: uppercase; font-weight: 600; margin-bottom: 5px;">
              {{$t('relSubsidy.mediumFleet')}}
            </div>
            <div style="color: #1976d2; font-size: 18px; font-weight: bold;">
              {{ numberFormatter(total.frota_total || 0) }}
            </div>
          </div>
          
          <div v-if="Number(total.motoristas_total) > 0" style="flex: 1; padding: 12px; border: 2px solid #1976d2; border-radius: 8px;">
            <div style="color: #666; font-size: 10px; text-transform: uppercase; font-weight: 600; margin-bottom: 5px;">
              {{$t('relSubsidy.driversCount')}}
            </div>
            <div style="color: #1976d2; font-size: 18px; font-weight: bold;">
              {{ Math.round(Number(total.motoristas_total)) }}
            </div>
          </div>

          <div style="flex: 1; padding: 12px; border: 2px solid #2e7d32; border-radius: 8px;">
            <div style="color: #666; font-size: 10px; text-transform: uppercase; font-weight: 600; margin-bottom: 5px;">
              {{$t('relSubsidy.fleetValue')}}
            </div>
            <div style="color: #2e7d32; font-size: 18px; font-weight: bold;">
              {{ currencyFormatter(total.valor_frota_total) }}
            </div>
          </div>
          
          <div style="flex: 1; padding: 12px; border: 2px solid #1976d2; border-radius: 8px;">
            <div style="color: #666; font-size: 10px; text-transform: uppercase; font-weight: 600; margin-bottom: 5px;">
              {{$t('relSubsidy.totalKm')}}
            </div>
            <div style="color: #1976d2; font-size: 18px; font-weight: bold;">
              {{ numberFormatter(total.km_total || 0) }}
            </div>
          </div>
          
          <div style="flex: 1; padding: 12px; border: 2px solid #2e7d32; border-radius: 8px;">
            <div style="color: #666; font-size: 10px; text-transform: uppercase; font-weight: 600; margin-bottom: 5px;">
              {{$t('relSubsidy.valueKm')}}
            </div>
            <div style="color: #2e7d32; font-size: 18px; font-weight: bold;">
              {{ currencyFormatter(total.valor_km_total) }}
            </div>
          </div>
        </div>
        
        <!-- Total Geral -->
        <div v-if="total && total.valor_frota_total !== undefined" style="background-color: #4a4a4a; color: white; padding: 18px; border-radius: 8px; margin-bottom: 25px; text-align: center;">
          <div style="font-size: 11px; text-transform: uppercase; font-weight: 600; margin-bottom: 5px; opacity: 0.9;">
            {{$t('relSubsidy.compensationTotal')}}
          </div>
          <div style="font-size: 28px; font-weight: bold;">
            {{ currencyFormatter(totalCompensationAmount) }}
          </div>
        </div>
        
        <!-- Tabela Resumo Total -->
        <div style="margin-bottom: 25px; page-break-inside: avoid;">
          <h3 style="color: #4a4a4a; margin-bottom: 12px; font-size: 16px; page-break-after: avoid;">{{ $t('relSubsidy.totalRemuneration') }}</h3>
          <table style="width: 100%; border-collapse: collapse; font-size: 8.5px; page-break-inside: auto;">
            <thead>
              <tr style="background-color: #f5f5f5; page-break-inside: avoid; page-break-after: avoid;">
                <th style="border: 1px solid #ddd; padding: 7px; text-align: left;">{{ $t('relSubsidy.headersTotal.typeVehicle') }}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: left;">{{ $t('relSubsidy.headersTotal.tarifFleet') }}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{ $t('relSubsidy.headersTotal.valueTarifFleet') }}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{ $t('relSubsidy.headersTotal.averageOperationalFleet') }}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{ $t('relSubsidy.headersTotal.valueFleetTotal') }}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: left;">{{ $t('relSubsidy.headersTotal.tarifKm') }}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{ $t('relSubsidy.headersTotal.valueTarifKm') }}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{ $t('relSubsidy.headersTotal.totalKm') }}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{ $t('relSubsidy.headersTotal.valueKmTotal') }}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{ $t('relSubsidy.headersTotal.total') }}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: left;">{{ $t('relSubsidy.headersTotal.contract') }}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: left;">{{ $t('relSubsidy.headersTotal.valueOrigin') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in totalTarifas" :key="index" style="page-break-inside: avoid !important; break-inside: avoid !important; -webkit-column-break-inside: avoid !important; display: table-row;">
                <td style="border: 1px solid #ddd; padding: 7px;">{{ item.descricao_tipo_veiculo }}</td>
                <td style="border: 1px solid #ddd; padding: 7px;">{{ item.descricao_tarifa_frota }}</td>
                <td style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{ item.valor_tarifa_frota ? currencyFormatter(item.valor_tarifa_frota) : '' }}</td>
                <td style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{ item.frota_operacional_media ? numberFormatter(item.frota_operacional_media) : '' }}</td>
                <td style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{ currencyFormatter(item.valor_total_frota) }}</td>
                <td style="border: 1px solid #ddd; padding: 7px;">{{ item.descricao_tarifa_km }}</td>
                <td style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{ item.valor_tarifa_km ? currencyFormatter(item.valor_tarifa_km) : '' }}</td>
                <td style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{ item.km_total ? currencyFormatter(item.km_total) : '' }}</td>
                <td style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{ currencyFormatter(item.valor_total_km) }}</td>
                <td style="border: 1px solid #ddd; padding: 7px; text-align: right; font-weight: bold;">{{ currencyFormatter(item.valor_total) }}</td>
                <td style="border: 1px solid #ddd; padding: 7px;">{{ item.cod_contrato_exibicao || '—' }}</td>
                <td style="border: 1px solid #ddd; padding: 7px;">{{ item.origem_valor_label }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <!-- Tabela Analítico KM -->
        <div style="margin-bottom: 25px; page-break-inside: avoid;">
          <h3 style="color: #4a4a4a; margin-bottom: 12px; font-size: 16px; page-break-after: avoid;">{{$t('relSubsidy.dayToDayAnalysisKm.title')}}</h3>
          <table style="width: 100%; border-collapse: collapse; font-size: 8.5px; page-break-inside: auto;">
            <thead>
              <tr style="background-color: #f5f5f5; page-break-inside: avoid; page-break-after: avoid;">
                <th style="border: 1px solid #ddd; padding: 7px; text-align: left;">{{$t('relSubsidy.dayToDayAnalysisKm.date')}}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: left;">{{$t('relSubsidy.dayToDayAnalysisKm.vehicleType')}}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{$t('relSubsidy.dayToDayAnalysisKm.totalKm')}}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: left;">{{$t('relSubsidy.dayToDayAnalysisKm.tarifKm')}}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{$t('relSubsidy.dayToDayAnalysisKm.valueTarifKm')}}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{$t('relSubsidy.dayToDayAnalysisKm.valueKmTotal')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in analiticoKm" :key="index" style="page-break-inside: avoid !important; break-inside: avoid !important; -webkit-column-break-inside: avoid !important; display: table-row;">
                <td style="border: 1px solid #ddd; padding: 7px;">{{ item.dt_referencia_extenso }}</td>
                <td style="border: 1px solid #ddd; padding: 7px;">{{ item.descricao_tipo_veiculo }}</td>
                <td style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{ currencyFormatter(item.km_total) }}</td>
                <td style="border: 1px solid #ddd; padding: 7px;">{{ item.descricao_tarifa_km }}</td>
                <td style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{ currencyFormatter(item.valor_tarifa_km) }}</td>
                <td style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{ currencyFormatter(item.valor_total_km) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <!-- Tabela Analítico Frota -->
        <div style="margin-bottom: 25px; page-break-inside: avoid;">
          <h3 style="color: #4a4a4a; margin-bottom: 12px; font-size: 16px; page-break-after: avoid;">{{$t('relSubsidy.dayToDayAnalysisFleet.title')}}</h3>
          <table style="width: 100%; border-collapse: collapse; font-size: 8.5px; page-break-inside: auto;">
            <thead>
              <tr style="background-color: #f5f5f5; page-break-inside: avoid; page-break-after: avoid;">
                <th style="border: 1px solid #ddd; padding: 7px; text-align: left;">{{$t('relSubsidy.dayToDayAnalysisFleet.date')}}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: left;">{{$t('relSubsidy.dayToDayAnalysisFleet.vehicleType')}}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{$t('relSubsidy.dayToDayAnalysisFleet.peakVehicleMorning')}}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{$t('relSubsidy.dayToDayAnalysisFleet.peakVehicleEvening')}}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{$t('relSubsidy.dayToDayAnalysisFleet.operational')}}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: left;">{{$t('relSubsidy.dayToDayAnalysisFleet.fleetTarif')}}</th>
                <th style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{$t('relSubsidy.dayToDayAnalysisFleet.totalFleetTarif')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in analiticoFrota" :key="index" style="page-break-inside: avoid !important; break-inside: avoid !important; -webkit-column-break-inside: avoid !important; display: table-row;">
                <td style="border: 1px solid #ddd; padding: 7px;">{{ item.dt_referencia_extenso }}</td>
                <td style="border: 1px solid #ddd; padding: 7px;">{{ item.descricao_tipo_veiculo }}</td>
                <td style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{ item.num_veiculos_pico_manha }}</td>
                <td style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{ item.num_veiculos_pico_tarde }}</td>
                <td style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{ currencyFormatter(item.frota_operacional) }}</td>
                <td style="border: 1px solid #ddd; padding: 7px;">{{ item.descricao_tarifa_frota }}</td>
                <td style="border: 1px solid #ddd; padding: 7px; text-align: right;">{{ currencyFormatter(item.valor_tarifa_frota) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </vue-html2pdf>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import EventBus from "@/utils/eventBus";
import DateUtils from "../utils/dateutils";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import VueHtml2pdf from "vue-html2pdf";

function sumScorecardDescontos(scorecards) {
  const list = scorecards || [];
  let desconto = 0;
  let pontos = null;
  for (let i = 0; i < list.length; i++) {
    desconto += Number(list[i].valor_desconto_aplicado) || 0;
    if (list[i].pontos_scorecard != null) {
      pontos = Number(list[i].pontos_scorecard);
    }
  }
  return {
    valor_desconto_scorecard: Math.round(desconto * 100) / 100,
    pontos_scorecard: pontos,
  };
}

function applyScorecardToTotal(total, valorDescontoScorecard) {
  const t = total ? { ...total } : {};
  const bruto =
    t.valor_total != null && t.valor_total !== ""
      ? Number(t.valor_total) || 0
      : (Number(t.valor_frota_total) || 0) + (Number(t.valor_km_total) || 0);
  const desconto = Number(valorDescontoScorecard) || 0;
  const liquido = Math.max(0, Math.round((bruto - desconto) * 100) / 100);
  return {
    ...t,
    valor_total_bruto: Math.round(bruto * 100) / 100,
    valor_desconto_scorecard: Math.round(desconto * 100) / 100,
    valor_total: liquido,
  };
}

export default {
  components: {
    MerusDataTable,
    CadastroToolbar,
    VueHtml2pdf,
  },
  data: () => ({
    headersAnaliticoFrota: [],
    headersAnaliticoKm: [],
    search: "",
    user: null,
    token: null,
    mensagemAutorizacaoDialog: "",
    autorizacaoDialog: false,
    displayedTotalTarifasItemsForExport: null,
    displayedAnaliticoKmItemsForExport: null,
    displayedAnaliticoFrotaItemsForExport: null,
    formValidado: false,
    idEmpresaSelected: null,
    idClienteSelected: null,
    mesSelected: null,
    anoSelected: null,
    empresas: [],
    clientes: [],
    linhas: [],
    anos: [],
    totalTarifas: [],
    total: {},
    cicloPagamento: null,
    loadingRelatorio: false,
    loadingPdf: false,
    analiticoKm: [],
    analiticoFrota: [],
    parametrosSetup: null,
    config: null,
    scorecardLista: [],
    scorecardResumo: { valor_desconto_scorecard: 0, pontos_scorecard: null },
    loadingScorecard: false,
    // Fechamento do mês: congela as viagens do período para o valor do subsídio parar de variar.
    recursos: [],
    fechamentoMes: null,
    fechamentoEmpresa: null,
    fechamentoAnoMes: null,
    carregandoFechamento: false,
    salvandoFechamento: false,
    dialogFecharMes: false,
    dialogReabrirMes: false,
    observacoesFechamento: "",
    motivoReabertura: "",
    htmlToPdfOptions: {
      margin: [10, 10, 10, 10],
      filename: 'relatorio_subsidio_mensal.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        logging: false,
        letterRendering: true,
        allowTaint: true
      },
      jsPDF: { 
        unit: 'mm', 
        format: 'a4', 
        orientation: 'landscape',
        compress: true
      }
    },
  }),
  computed: {
    /** Frota média e distância percorrida encolhem para 2 colunas quando o card de mão de obra aparece. */
    mdCardMaoObra() {
      return this.total && Number(this.total.motoristas_total) > 0 ? 2 : 3;
    },
    clientesSelect() {
      if (!this.idEmpresaSelected) return [];
      return this.clientes.filter((c) => c.id_empresa == this.idEmpresaSelected);
    },
    cicloPagamentoCaption() {
      const c = this.cicloPagamento;
      if (!c || !c.inicio || !c.fim) return '';
      let tipo = this.$t('relSubsidy.paymentCycle.monthly');
      if (c.tipo === 'QUINZENAL') {
        tipo = this.$t('relSubsidy.paymentCycle.biweekly');
      } else if (c.tipo === 'DIAS') {
        tipo = this.$t('relSubsidy.paymentCycle.customDays', {
          dias: c.dias_ciclo_pagamento || c.dias || '?',
        });
      }
      const range = this.$t('relSubsidy.paymentCycle.range', {
        inicio: this.formatCicloDia(c.inicio),
        fim: this.formatCicloDia(c.fim),
      });
      let caption = `${this.$t('relSubsidy.paymentCycle.label')}: ${tipo} (${range})`;
      // Contrato operacional sem ciclo próprio herda o do contrato de controle;
      // dizer de onde veio evita a leitura de que o operacional o define.
      if (c.origem === 'CONTROLE' && c.cod_contrato_ciclo) {
        caption += ` — ${this.$t('relSubsidy.paymentCycle.fromControl', {
          contrato: c.cod_contrato_ciclo,
        })}`;
      }
      return caption;
    },
    podeFecharMes() {
      if (this.user && this.user.is_superadmin === 1) return true;
      return this.recursos.some((r) => r.rota === '/api/v1.0/subsidio/insertfechamentomes');
    },
    podeReabrirMes() {
      if (this.user && this.user.is_superadmin === 1) return true;
      return this.recursos.some((r) => r.rota === '/api/v1.0/subsidio/reabrirfechamentomes');
    },
    mesEstaFechado() {
      return !!this.fechamentoMes;
    },
    /**
     * Se o status já foi carregado para a empresa/mês que estão selecionados agora. Vale
     * tanto para mês aberto quanto fechado — é o que autoriza a ação de fechar, para o
     * usuário não encerrar um mês diferente do que consultou.
     */
    statusFechamentoCarregado() {
      if (this.fechamentoEmpresa == null || this.fechamentoAnoMes == null) return false;
      return (
        Number(this.fechamentoEmpresa) === Number(this.idEmpresaSelected) &&
        this.fechamentoAnoMes === `${this.anoSelected}-${this.mesSelected}`
      );
    },
    /**
     * Existe fechamento ativo para os filtros atuais. Se o usuário troca empresa ou mês, o
     * indicativo some até o próximo carregamento.
     */
    fechamentoCorrespondeAosFiltros() {
      return !!this.fechamentoMes && this.statusFechamentoCarregado;
    },
    fechamentoResumo() {
      const f = this.fechamentoMes;
      if (!f) return '';
      return this.$t('closingMonth.closedBanner', {
        data: this.formatDataHora(f.dt_fechamento),
        usuario: f.nome_usuario_fechamento || '-',
        valor: f.valor_total_subsidio != null ? this.currencyFormatter(f.valor_total_subsidio) : '-',
      });
    },
    /**
     * A tarifa ainda não é congelada nesta fase: se o total recalculado saiu do
     * valor gravado no fechamento, o indicativo vira alerta em vez de mentir que está estável.
     */
    fechamentoDivergente() {
      if (!this.fechamentoCorrespondeAosFiltros) return false;
      const congelado = this.fechamentoMes.valor_total_subsidio;
      if (congelado == null) return false;
      if (!this.total || this.total.valor_frota_total === undefined) return false;
      return Math.abs(Number(congelado) - Number(this.totalCompensationAmount)) > 0.01;
    },
    fechamentoDivergenciaTexto() {
      if (!this.fechamentoDivergente) return '';
      return this.$t('closingMonth.divergence', {
        congelado: this.currencyFormatter(this.fechamentoMes.valor_total_subsidio),
        atual: this.currencyFormatter(this.totalCompensationAmount),
      });
    },
    hasScorecardMelibrasil() {
      return this.parametrosSetup && this.parametrosSetup.has_subsidio_scorecard_melibrasil == 1;
    },
    totalCompensationAmount() {
      const t = this.total;
      if (!t) return 0;
      if (t.valor_total != null && t.valor_total !== "") {
        return Number(t.valor_total) || 0;
      }
      const bruto = (Number(t.valor_frota_total) || 0) + (Number(t.valor_km_total) || 0);
      const desc = Number(t.valor_desconto_scorecard) || 0;
      return Math.max(0, Math.round((bruto - desc) * 100) / 100);
    },
    currencyFormatter() {
      const currencyCode = this.$t('contract.currencyCode') || 'BRL';
      const localeCode = this.$t('contract.localeCode') || 'pt-BR';
      
      return (value) => {
        if (value === null || value === undefined) return '';
        return new Intl.NumberFormat(localeCode, {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: 2,
          maximumFractionDigits: 4
        }).format(value);
      };
    },
    numberFormatter() {
      const localeCode = this.$t('contract.localeCode') || 'pt-BR';
      
      return (value, minDecimals = 2, maxDecimals = 2) => {
        if (value === null || value === undefined) return '';
        return new Intl.NumberFormat(localeCode, {
          minimumFractionDigits: minDecimals,
          maximumFractionDigits: maxDecimals
        }).format(value);
      };
    },
    headersTotal() {
      const h = [
        { text: this.$t('relSubsidy.headersTotal.typeVehicle'), value: "descricao_tipo_veiculo", sortable: true, filtrable: true },
        { text: this.$t('relSubsidy.headersTotal.tarifFleet'), value: "descricao_tarifa_frota", sortable: true, filtrable: true },
        { text: this.$t('relSubsidy.headersTotal.valueTarifFleet'), value: "valor_tarifa_frota", sortable: true, filtrable: true },
        { text: this.$t('relSubsidy.headersTotal.averageOperationalFleet'), value: "frota_operacional_media", sortable: true, filtrable: true },
        { text: this.$t('relSubsidy.headersTotal.valueFleetTotal'), value: "valor_total_frota", sortable: true, filtrable: true },
        { text: this.$t('relSubsidy.headersTotal.tarifKm'), value: "descricao_tarifa_km", sortable: true, filtrable: true },
        { text: this.$t('relSubsidy.headersTotal.valueTarifKm'), value: "valor_tarifa_km", sortable: true, filtrable: true },
        { text: this.$t('relSubsidy.headersTotal.totalKm'), value: "km_total", sortable: true, filtrable: true },
        { text: this.$t('relSubsidy.headersTotal.valueKmTotal'), value: "valor_total_km", sortable: true, filtrable: true },
      ];
      h.push(
        { text: this.$t('relSubsidy.headersTotal.total'), value: "valor_total", sortable: true, filtrable: true },
        { text: this.$t('relSubsidy.headersTotal.contract'), value: "cod_contrato_exibicao", sortable: false, filtrable: true },
        { text: this.$t('relSubsidy.headersTotal.valueOrigin'), value: "origem_valor_label", sortable: false, filtrable: true }
      );
      return h;
    },
    defaultSortTotal() {
      return [
        { value: 'descricao_tipo_veiculo', options: { text: this.$t('system.labels.increasing'), value: 1 } }];
    },
    defaultMultiSortAnalitico() {
      return [
        { value: 'dt_referencia_extenso', options: { text: this.$t('routs.increasing'), value: 1 } },
        { value: 'descricao_tipo_veiculo', options: { text: this.$t('routs.increasing'), value: 1 } }]
    },
    meses() {
      return [
        { text: this.$t('months.january'), value: 1 },
        { text: this.$t('months.february'), value: 2 },
        { text: this.$t('months.march'), value: 3 },
        { text: this.$t('months.april'), value: 4 },
        { text: this.$t('months.may'), value: 5 },
        { text: this.$t('months.june'), value: 6 },
        { text: this.$t('months.july'), value: 7 },
        { text: this.$t('months.august'), value: 8 },
        { text: this.$t('months.september'), value: 9 },
        { text: this.$t('months.october'), value: 10 },
        { text: this.$t('months.november'), value: 11 },
        { text: this.$t('months.december'), value: 12 }];
    },
    mesesDisponiveis() {
      if (!this.anoSelected) {
        return this.meses;
      }
      
      const hoje = new Date();
      const anoAtual = hoje.getFullYear();
      const mesAtual = hoje.getMonth() + 1; // Janeiro = 1
      
      // Se o ano selecionado for o ano atual, limita até o mês anterior
      if (this.anoSelected === anoAtual) {
        return this.meses.filter(mes => mes.value < mesAtual);
      }
      
      // Para anos anteriores, mostra todos os meses
      return this.meses;
    },
    pdfSubtitle() {
      if (!this.mesSelected || !this.anoSelected) {
        return "";
      }
      const mesTexto = this.meses.find(m => m.value === this.mesSelected)?.text || "";
      const empresaTexto = this.empresas.find(e => e.id_empresa === this.idEmpresaSelected)?.razao_social || "";
      
      return `${empresaTexto} | ${mesTexto}/${this.anoSelected}`;
    },
    pdfDadosEmissao() {
      const usuario = this.user.nome_usuario || "";
      const data = new Date().toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });

      return this.$t('relSubsidy.reportIssuedBy', { usuario: usuario, data: data });
    }
  },
  watch: {
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    }
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.populaRecursos();
    this.initialize();
  },
  methods: {

    logout() {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("api");
      var id = window.setTimeout(function () { }, 0);
      while (id--) {
        window.clearTimeout(id);
      }
      this.$router.push({ path: "/" });
    },
    formatDataHora(valor) {
      if (!valor) return '';
      const d = new Date(valor);
      if (isNaN(d.getTime())) return String(valor);
      const pad = (n) => String(n).padStart(2, '0');
      return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    populaRecursos() {
      if (this.user && this.user.is_superadmin === 1) return;
      apiController.request(apiController.endpoints.getRecursosusuario, {
        params: { id: this.user && this.user.id_usuario },
        silent: true,
        onSuccess: (response) => {
          this.recursos = response.data || [];
        },
        onError: () => {
          this.recursos = [];
        },
      });
    },
    /**
     * Status do fechamento da empresa/mês selecionados. Chamado junto com o relatório para
     * o indicativo aparecer com os mesmos filtros que geraram os números na tela.
     */
    carregaFechamentoMes() {
      if (!this.idEmpresaSelected || !this.mesSelected || !this.anoSelected) {
        this.fechamentoMes = null;
        this.fechamentoEmpresa = null;
        this.fechamentoAnoMes = null;
        return;
      }
      this.carregandoFechamento = true;
      const empresa = this.idEmpresaSelected;
      const anoMes = `${this.anoSelected}-${this.mesSelected}`;
      apiController.request(apiController.endpoints.subsidioGetFechamentomesativo, {
        data: { idempresa: empresa, ano: this.anoSelected, mes: this.mesSelected },
        silent: true,
        onSuccess: (response) => {
          this.fechamentoMes = (response.data && response.data.fechamento) || null;
          this.fechamentoEmpresa = empresa;
          this.fechamentoAnoMes = anoMes;
          this.carregandoFechamento = false;
        },
        onError: () => {
          // Sem permissão de leitura o indicativo não aparece e fechar fica indisponível:
          // sem saber o status, encerrar o mês seria um tiro no escuro.
          this.fechamentoMes = null;
          this.fechamentoEmpresa = null;
          this.fechamentoAnoMes = null;
          this.carregandoFechamento = false;
        },
      });
    },
    abrirDialogFecharMes() {
      this.observacoesFechamento = "";
      this.dialogFecharMes = true;
    },
    confirmarFecharMes() {
      this.salvandoFechamento = true;
      apiController.request(apiController.endpoints.subsidioInsertFechamentomes, {
        data: {
          idempresa: this.idEmpresaSelected,
          ano: this.anoSelected,
          mes: this.mesSelected,
          observacoes: this.observacoesFechamento || null,
          // O total exibido é o número que o usuário está atestando ao encerrar o mês.
          valor_total_subsidio: this.totalCompensationAmount,
          resumo_snapshot: {
            total: this.total,
            total_por_tipo: this.totalTarifas,
            ciclo_pagamento: this.cicloPagamento,
          },
        },
        onSuccess: (response) => {
          this.salvandoFechamento = false;
          this.dialogFecharMes = false;
          EventBus.$emit('show-alert', {
            mensagem: this.$t('closingMonth.closeSuccess', {
              viagens: (response.data && response.data.qtd_viagens) || 0,
            }),
          });
          this.carregaFechamentoMes();
        },
        onError: (error) => {
          this.salvandoFechamento = false;
          EventBus.$emit('show-error', { error });
        },
      });
    },
    abrirDialogReabrirMes() {
      this.motivoReabertura = "";
      this.dialogReabrirMes = true;
    },
    confirmarReabrirMes() {
      if (!this.motivoReabertura || !this.motivoReabertura.trim()) return;
      this.salvandoFechamento = true;
      apiController.request(apiController.endpoints.subsidioReabrirfechamentomes, {
        data: {
          id_fechamento_mes: this.fechamentoMes.id_fechamento_mes,
          motivo_reabertura: this.motivoReabertura,
        },
        onSuccess: () => {
          this.salvandoFechamento = false;
          this.dialogReabrirMes = false;
          EventBus.$emit('show-alert', { mensagem: this.$t('closingMonth.reopenSuccess') });
          this.carregaFechamentoMes();
        },
        onError: (error) => {
          this.salvandoFechamento = false;
          EventBus.$emit('show-error', { error });
        },
      });
    },
    /**
     * Código do contrato que identifica a linha.
     *
     * O relatório resolve a tarifa pelo contrato operacional, mas quem
     * representa o acordo comercial é o contrato de controle vinculado a ele —
     * é esse que o cliente reconhece. O operacional fica como fallback (e
     * sempre visível no tooltip) para quando não há controle vinculado.
     */
    codContratoExibicao(item) {
      return item.cod_contrato_controle || item.cod_contrato_valor || '';
    },
    /** Detalha os dois contratos por trás da coluna: controle e operacional. */
    contratoTooltip(item) {
      const t = (k) => this.$t(`relSubsidy.valueOrigin.${k}`);
      const linhas = [];
      if (item.cod_contrato_controle) {
        linhas.push(`${t('controlContract')}: ${item.cod_contrato_controle}`);
      }
      if (item.cod_contrato_valor) {
        linhas.push(`${t('operationalContract')}: ${item.cod_contrato_valor}`);
      }
      return linhas.length ? linhas.join('\n') : t('noContract');
    },
    /**
     * Explica de onde saiu o `valor_total` da linha: da fórmula cadastrada no
     * banco, da composição fixa do sistema, ou da composição fixa depois de a
     * fórmula falhar — caso em que o motivo do erro vai no tooltip.
     */
    origemValor(item) {
      const t = (k) => this.$t(`relSubsidy.valueOrigin.${k}`);
      const contrato = item.cod_contrato_valor
        ? `${t('operationalContract')}: ${item.cod_contrato_valor}`
        : t('noContract');
      const controle = item.cod_contrato_controle
        ? `${t('controlContract')}: ${item.cod_contrato_controle}`
        : null;
      // A fórmula pode estar cadastrada no contrato de controle, e não no
      // operacional que rege a linha; só mostra a origem quando difere.
      const origemFormula =
        item.cod_contrato_calculo && item.cod_contrato_calculo !== item.cod_contrato_valor
          ? `${t('formulaContract')}: ${item.cod_contrato_calculo}`
          : null;

      if (item.valor_total_origem === 'LINHAS') {
        return {
          label: t('lines'),
          color: 'primary',
          icon: 'mdi-format-list-bulleted',
          tooltip: [t('linesTooltip'), ...this.descreveLinhasValor(item), controle, contrato]
            .filter(Boolean)
            .join('\n'),
        };
      }

      if (item.valor_total_origem === 'FORMULA') {
        const calculo = item.calculo_valor_codigo
          ? `${t('calc')}: ${item.calculo_valor_codigo}`
          : t('formula');
        return {
          label: item.calculo_valor_codigo || t('formula'),
          color: 'primary',
          icon: 'mdi-function-variant',
          tooltip: [t('formulaTooltip'), calculo, controle, contrato, origemFormula]
            .filter(Boolean)
            .join('\n'),
        };
      }

      if (item.valor_total_formula_erro) {
        return {
          label: t('standard'),
          color: 'warning',
          icon: 'mdi-alert-outline',
          tooltip: [
            t('errorTooltip'),
            item.calculo_valor_codigo ? `${t('calc')}: ${item.calculo_valor_codigo}` : null,
            controle,
            contrato,
            origemFormula,
            `${t('reason')}: ${item.valor_total_formula_erro}`,
          ]
            .filter(Boolean)
            .join('\n'),
        };
      }

      return {
        label: t('standard'),
        color: 'grey',
        icon: null,
        tooltip: [t('standardTooltip'), controle, contrato].filter(Boolean).join('\n'),
      };
    },
    /** Uma linha de texto por linha de valor: `tarifa: valor × grandeza (qtd) = total`. */
    descreveLinhasValor(item) {
      const t = (k, p) => this.$t(`relSubsidy.valueOrigin.${k}`, p);
      return (item.linhas_valor || []).flatMap((l) => {
        const qtd = l.quantidade != null ? Number(l.quantidade).toLocaleString(this.$t('contract.localeCode') || 'pt-BR') : '—';
        let txt = `${l.descricao_tarifa || l.cod_tarifa}: ${this.currencyFormatter(l.valor || 0)} × ` +
          `${l.grandeza_codigo || '—'} (${qtd}) = ${this.currencyFormatter(l.valor_total || 0)}`;
        if (l.filtro_codigo) {
          txt += ` · ${t('filter')} ${l.filtro_codigo}`;
          if (l.filtro_chaves_avaliadas != null) {
            txt += ` (${t('filterApproved', { aprovadas: l.filtro_chaves_aprovadas, avaliadas: l.filtro_chaves_avaliadas })})`;
          }
        }
        if (l.aviso) txt += ` ⚠ ${t(`warnings.${l.aviso}`)}`;
        // Mão de obra por faixa: quantos veículos caíram em cada faixa.
        const locale = this.$t('contract.localeCode') || 'pt-BR';
        const usos = (l.faixas_uso || []).map(
          (u) =>
            `   · ${this.$t(`contractV2.laborRegime${u.codigo}`)}: ` +
            `${t('rangeUsage', {
              veiculos: u.veiculos,
              preco: this.currencyFormatter(u.preco),
              veiculoMes: Number(u.veiculo_mes).toLocaleString(locale, { maximumFractionDigits: 3 }),
            })}`,
        );
        return [txt].concat(usos);
      });
    },
    formatCicloDia(ymd) {
      if (!ymd) return '';
      const s = String(ymd);
      if (s.length < 10) return s;
      const [y, m, d] = s.substring(0, 10).split('-');
      return `${d}/${m}/${y}`;
    },
    initialize() {
      this.populaEmpresas();
      this.populaClientes();
      this.populaLinhas();
      this.populaAnos();
      this.fetchParametrosSetup();
      this.fetchConfig();
      // Define mês anterior e ano atual como padrão
      const hoje = new Date();
      const mesAnterior = hoje.getMonth(); // getMonth() retorna 0-11, então isso dá o mês anterior em 1-12
      const anoAtual = hoje.getFullYear();
      
      // Se estamos em Janeiro, define Dezembro do ano anterior
      if (mesAnterior === 0) {
        this.mesSelected = 12;
        this.anoSelected = anoAtual - 1;
      } else {
        this.mesSelected = mesAnterior;
        this.anoSelected = anoAtual;
      }
    },
    populaClientes() {
      apiController.request(apiController.endpoints.getallClientes, {
        onSuccess: (response) => {
          const list = Array.isArray(response.data) ? response.data : [];
          this.clientes = list
            .filter((c) => c.ativo === 1 || c.ativo === true || c.ativo == null)
            .sort((a, b) =>
              String(a.nome_cliente || "").localeCompare(String(b.nome_cliente || ""), undefined, {
                sensitivity: "base",
              })
            );
        },
      });
    },
    populaLinhas() {
      apiController.request(apiController.endpoints.getLinhasativas, {
        onSuccess: (response) => {
          this.linhas = response.data;
        },
      });
    },
    resolveIdLinhasFilter() {
      if (!this.idClienteSelected) return null;
      const list = this.linhas.filter(
        (l) => l.id_empresa == this.idEmpresaSelected && l.id_cliente == this.idClienteSelected
      );
      const ids = list.map((l) => l.id_linha);
      return ids.length > 0 ? ids : null;
    },
    onEmpresaSelectChanged() {
      this.idClienteSelected = null;
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        silent: true,
        onSuccess: (response) => {
          this.empresas = response.data;
        },
        onError: (e) => {
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog = this.$t('system.messages.accessDenied');
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    populaAnos() {
      // Gera lista de anos dos últimos 5 anos até o ano atual (não inclui futuro)
      const anoAtual = new Date().getFullYear();
      for (let i = anoAtual - 5; i <= anoAtual; i++) {
        this.anos.push(i);
      }
      this.anos.reverse(); // Ordena do mais recente para o mais antigo
    },
    fetchParametrosSetup() {
      apiController.request(apiController.endpoints.getallParametrossetup, {
        onSuccess: (response) => {
          this.parametrosSetup = response.data[0];
        },
      });
    },
    fetchConfig() {
      apiController.request(apiController.endpoints.getallConfig, {
        silent: true,
        onSuccess: (response) => {
          this.config = (response.data && response.data[0]) || null;
        },
      });
    },
    /**
     * Limites do mês para o cálculo de contrato: do início do dia operacional do dia 1 até um
     * segundo antes do início do dia operacional do mês seguinte (mesmo corte do
     * getrelatoriomensal), senão as viagens da madrugada caem no mês errado.
     */
    monthBoundsOperacional() {
      const hora = (this.config && this.config.hora_inicial_dia_operacao) || "00:00";
      const [h, m] = String(hora).split(":").map(Number);
      const dti = new Date(this.anoSelected, this.mesSelected - 1, 1, h || 0, m || 0, 0, 0);
      const dtf = new Date(this.anoSelected, this.mesSelected, 1, h || 0, m || 0, 0, 0);
      dtf.setSeconds(dtf.getSeconds() - 1);
      return {
        dti: DateUtils.getDateSQLFormatted(dti),
        dtf: DateUtils.getDateSQLFormatted(dtf),
      };
    },
    anoMesRelatorio() {
      if (!this.anoSelected || !this.mesSelected) return null;
      const pad = (n) => String(n).padStart(2, "0");
      return `${this.anoSelected}-${pad(this.mesSelected)}`;
    },
    fetchScorecardsMensal() {
      if (!this.hasScorecardMelibrasil) {
        this.scorecardLista = [];
        this.scorecardResumo = { valor_desconto_scorecard: 0, pontos_scorecard: null };
        return;
      }
      const anoMes = this.anoMesRelatorio();
      if (!anoMes) return;
      this.loadingScorecard = true;
      apiController.request(apiController.endpoints.subsidioMelibrasilScorecard, {
        query: { ano_mes: anoMes },
        silent: true,
        onSuccess: (response) => {
          this.scorecardLista = Array.isArray(response.data) ? response.data : [];
          this.scorecardResumo = sumScorecardDescontos(this.scorecardLista);
          this.tryAplicarScorecardMelibrasilDesconto();
          this.loadingScorecard = false;
        },
        onError: (e) => {
          this.loadingScorecard = false;
          if (e.response && e.response.status === 403) {
            this.scorecardLista = [];
            return;
          }
          EventBus.$emit("show-error", { error: e });
        },
      });
    },
    tryAplicarScorecardMelibrasilDesconto() {
      if (!this.hasScorecardMelibrasil || !this.total) return;
      const desc = this.scorecardResumo.valor_desconto_scorecard || 0;
      if (desc <= 0) return;
      this.total = applyScorecardToTotal(this.total, desc);
    },
    onAnoChange() {
      // Quando o ano muda, valida se o mês selecionado ainda é válido
      const hoje = new Date();
      const anoAtual = hoje.getFullYear();
      const mesAtual = hoje.getMonth() + 1;
      
      // Se o ano atual foi selecionado e o mês escolhido é >= ao mês atual, reseta
      if (this.anoSelected === anoAtual && this.mesSelected >= mesAtual) {
        this.mesSelected = null;
      }
    },
    populaRelatorio() {
      this.$refs.form.validate();
      if (this.formValidado) {
        this.geraRelatorio();
        this.$nextTick(() => { this.$refs.form.resetValidation(); });
      }
    },
    geraRelatorio() {
      this.loadingRelatorio = true;
      this.carregaFechamentoMes();
      // O total vem do cálculo de contrato (mesmo da tela diária); os analíticos dia a dia
      // km/frota ainda só existem no relatório mensal antigo.
      let pendentes = 2;
      const concluiu = () => {
        pendentes -= 1;
        if (pendentes === 0) this.loadingRelatorio = false;
      };
      this.geraAnaliticosMensais(concluiu);
      this.geraTotalContratos(concluiu);
    },
    geraAnaliticosMensais(done) {
      const payload = {
        idempresa: this.idEmpresaSelected,
        idcliente: this.idClienteSelected || null,
        idlinhas: this.resolveIdLinhasFilter(),
        mes: this.mesSelected,
        ano: this.anoSelected,
      };
      apiController.request(apiController.endpoints.subsidioFriburgoGetRelatoriomensal, {
        data: payload,
        silent: true,
        onSuccess: (response) => {
          const ok = response.data && !response.data.erro;
          this.analiticoKm = ok ? response.data.km || [] : [];
          this.analiticoFrota = ok ? response.data.frota || [] : [];
          done();
        },
        onError: (e) => {
          this.analiticoKm = [];
          this.analiticoFrota = [];
          this.tratarErroRelatorio(e);
          done();
        },
      });
    },
    geraTotalContratos(done) {
      const { dti, dtf } = this.monthBoundsOperacional();
      const payload = {
        dti,
        dtf,
        idempresa: this.idEmpresaSelected,
        idcliente: this.idClienteSelected || null,
        idlinhas: this.resolveIdLinhasFilter(),
        idveiculos: null,
      };
      apiController.request(apiController.endpoints.subsidioFriburgoGetSubsidiototal, {
        data: payload,
        silent: true,
        onSuccess: (response) => {
          if (!response.data.erro) {
            // Só entram as linhas em que houve km e/ou frota, independente das
            // linhas cadastradas no contrato.
            const tt = (response.data.tarifas || []).filter(
              (r) => Number(r.km_total) > 0 || Number(r.frota_operacional_media) > 0
            );
            const tot = response.data.total || {};
            // Campos planos: os slots da tabela usam os métodos abaixo, mas o
            // CSV e o PDF exportam o valor cru da coluna.
            tt.forEach((r) => {
              r.cod_contrato_exibicao = this.codContratoExibicao(r);
              r.origem_valor_label = this.origemValor(r).label;
            });
            // A tela lê os totais pelos nomes do relatório mensal; o cálculo de contrato
            // usa os nomes da tela diária.
            const totalTela = {
              ...tot,
              frota_total: tot.frota_operacional_media,
              valor_frota_total: tot.valor_total_frota,
              valor_km_total: tot.valor_total_km,
            };
            this.totalTarifas = [...tt];
            this.total = totalTela;
            this.cicloPagamento = response.data.ciclo_pagamento || null;
            this.fetchScorecardsMensal();
          } else {
            this.limpaTotalContratos();
          }
          done();
        },
        onError: (e) => {
          this.limpaTotalContratos();
          this.tratarErroRelatorio(e);
          done();
        },
      });
    },
    limpaTotalContratos() {
      this.cicloPagamento = null;
      this.scorecardLista = [];
      this.scorecardResumo = { valor_desconto_scorecard: 0, pontos_scorecard: null };
    },
    tratarErroRelatorio(e) {
      console.log(this.$t('system.messages.errorAxios'));
      console.log(e.message);
      if (e.message == "Request failed with status code 401") {
        this.mensagemAutorizacaoDialog = this.$t('system.messages.accessDenied');
        this.autorizacaoDialog = true;
      }
    },
    exportarPaginaPDF() {
      this.loadingPdf = true;
      this.$refs.html2Pdf.generatePdf();
      
      // Timeout de segurança para garantir que o loading seja desativado
      setTimeout(() => {
        if (this.loadingPdf) {
          this.loadingPdf = false;
        }
      }, 30000); // 30 segundos
    },
    onPdfStart() {
      this.loadingPdf = true;
      // console.log('PDF: Geração iniciada');
    },
    onPdfProgress(progress) {
      console.log('PDF Progress:', progress);
    },
    onPdfComplete() {
      // console.log('PDF: Geração completa');
      // Aguarda um pouco antes de fechar o loading para garantir que o download iniciou
      setTimeout(() => {
        this.loadingPdf = false;
      }, 1000);
    },
    beforeDownload() {
      // console.log('PDF: Antes do download');
    },
    onPdfDownloaded() {
      // console.log('PDF: Download concluído');
      this.loadingPdf = false;
    },
  },
};
</script>

<style scoped>
</style>

